import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  name: string;
}

export function useAddCompany() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: Params) =>
      post({
        url: `/companies`,
        body: params,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getCompanies() });
      queryClient.invalidateQueries({ queryKey: queryKeys.getCompanies('all') });
      queryClient.invalidateQueries({ queryKey: queryKeys.getCompanies('active') });
    },
  });

  const addCompany = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    addCompany,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
